export const PhaseInOutStatus = [
  { id: 0, name: "phaseIn", value: false, displayName: "Phase In" },
  { id: 1, name: "phaseOut", value: true, displayName: "Phase Out" },
];
